// imports ...

import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from '@angular/core';

@Directive({
  selector: '[appScrollNearEnd]',
})
export class ScrollNearEndDirective implements OnInit {
  @Output() nearEnd: EventEmitter<void> = new EventEmitter<void>();

  /**
   * threshold in PX when to emit before page end scroll
   */
  @Input() threshold = 100;

  private window!: Window;

  constructor(private el: ElementRef) {}

  ngOnInit(): void {
    // save window object for type safety
    // this.window = window;
  }

  @HostListener('scroll', ['$event.target'])
  elementScrollEvent(scrollElement: HTMLElement) {
    const heightOfElement = scrollElement.scrollHeight;
    const currentScrolledY = scrollElement.scrollTop;
    const innerHeight = scrollElement.clientHeight;

    const distanceFromBottom =
      heightOfElement - (currentScrolledY + innerHeight);
    if (distanceFromBottom < this.threshold) {
      this.nearEnd.emit();
    }
  }
}
